import { useEffect } from "react";
import { useManageOrganizationContext } from "../ManageOrganizationContext";
import { ManageOrganizationBreadCrumbs } from "./BreadCrumbs";
import { CrmTab } from "./CrmTab";

export function ManageOrganization() {
    const { currentTab, setCurrentTab, crm, crmProject, crmConfig, setAboveLayout } = useManageOrganizationContext();
    useEffect(()=>{
        setAboveLayout(<ManageOrganizationBreadCrumbs/>)
    },[setAboveLayout])
    return (
        <CrmTab />
        // <Tabs
        //     defaultValue="crm"
        //     value={currentTab}
        //     onValueChange={(value) => { setCurrentTab(value as ManageOrganizationTabs) }}
        //     className="flex flex-col flex-1"
        // >
        //     <TabsList className="justify-between w-full [&>*]:flex-1 h-auto">
        //         <TabsTrigger value="crm" className="">
        //             <div className="">
        //                 <p>CRM Settings</p>
        //                 <p className="text-xs">{crm ? crm.name : <>&nbsp;</>}</p>
        //             </div>
        //         </TabsTrigger>
        //         <TabsTrigger value="crm_project" disabled={!crm}>
        //             <div className="">
        //                 <p>CRM Project Settings</p>
        //                 <p className="text-xs">{crmProject ? crmProject.name : !crm ? "Select CRM" : <>&nbsp;</>}</p>
        //             </div>
        //         </TabsTrigger>
        //         <TabsTrigger value="crm_config" disabled={!crmProject}>
        //             <div className="">
        //                 <p>CRM Survey Settings</p>
        //                 <p className="text-xs">{crmConfig ? crmConfig.name : !crmProject ? "Select CRM Project" : <>&nbsp;</>}</p>
        //             </div>
        //         </TabsTrigger>
        //     </TabsList>
        //     <TabsContent value="crm" className={cn("flex flex-col",{
        //         "flex-1": currentTab === "crm",
        //         "hidden": currentTab !== "crm"
        //     })}>
        //         <CrmTab />
        //     </TabsContent>
        //     <TabsContent value="crm_project" className={cn("flex flex-col",{
        //         "flex-1": currentTab === "crm_project",
        //         "hidden": currentTab !== "crm_project"
        //     })}>
        //         <CrmProjectsTab />
        //     </TabsContent>
        //     <TabsContent value="crm_config" className={cn("flex flex-col",{
        //         "flex-1": currentTab === "crm_config",
        //         "hidden": currentTab !== "crm_config",
        //     })}>
        //         <CrmConfigsTab/>
        //     </TabsContent>
        // </Tabs>
    )
}
